import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_SharpStar.scss'
import PropTypes from 'prop-types';

class SharpStar extends React.Component {
  static propTypes = {
    full: PropTypes.bool,
    half: PropTypes.bool,
    size: PropTypes.number,
    className: PropTypes.string,
    cursorChanges: PropTypes.bool
  }

  render () {
    const filledStar = 'icon-star-filled'
    const emptyStar = 'icon-star-empty'
    const halfFullStar = 'icon-star-half'
    let className = styles['handy']
    if (this.props.full) {
      className = className + ' ' + (this.props.half ? halfFullStar : filledStar)
    } else {
      className = className + ' ' + (this.props.half ? emptyStar : emptyStar)
    }
    let size = ''
    if (this.props.size === 3) {
      size = styles['three-x']
    } else if (this.props.size === 2) {
      size = styles['two-x']
    }
    className = `${className} ${size} ${this.props.className}`

    let cursorChanges = this.props.cursorChanges
    return (
      cursorChanges ? <i className={className} /> : <i className={className} style={{cursor: 'default'}} />
    )
  }
}

export default (SharpStar)
